if (!customElements.get('adev-cart-drawer')) {
    customElements.define('adev-cart-drawer', class adevCartDrawer extends HTMLElement {
        constructor() {
            super();
        }

        isOpened() {
            return this.classList.contains('is--active');
        }

        open() {
            this.classList.add('is--active');
            document.dispatchEvent(new CustomEvent('adev:open-overlay', { bubbles: true }));
        }

        close() {
            this.classList.remove('is--active');
            document.dispatchEvent(new CustomEvent('adev:close-overlay', { bubbles: true }));
        }

        loadingState(state = true) {
            if (state) {
                this.classList.add('is--loading');
                return;
            }

            this.classList.remove('is--loading');
        }

        initCloseButton() {
            const closeButton = this.querySelector('[data-adev-cart-drawer="close"]');
            if (!closeButton) return;

            closeButton.addEventListener('click', this.close.bind(this));
        }

        setupEvents() {
            document.addEventListener('adev:cart-drawer:refresh', this.refreshWithData.bind(this));

            document.addEventListener('adev:cart-drawer:loading', (e) => {
                this.loadingState(e.detail);
            });

            document.addEventListener('adev:overlay-click', this.close.bind(this));

            document.addEventListener('adev:open-cart-drawer', this.open.bind(this));
            document.addEventListener('adev:close-cart-drawer', this.close.bind(this));
        }

        initQuantityChange() {
            this.querySelectorAll('adev-quantity-selector').forEach((quantitySelector) => {
                quantitySelector.addEventListener('adev:quantity:changed', window.adev.Utils.debounce((newQuantity) => {
                    this.submitForm();
                }, 400));
            });
        }

        refreshWithData(event) {
            this.renderContents(event.detail);
        }

        renderContents(sections) {
            const domParserInstance = new DOMParser();

            if (sections.hasOwnProperty('adev-cart-drawer')) {
                const parsedCartDrawer = domParserInstance.parseFromString(sections['adev-cart-drawer'], 'text/html');
                const newCartDrawerContents = parsedCartDrawer.querySelector('[data-adev-cart-drawer="form"]');

                const contentsEl = this.querySelector('[data-adev-cart-drawer="form"]');
                if (contentsEl) contentsEl.innerHTML = newCartDrawerContents.innerHTML;
            }

            document.dispatchEvent(new CustomEvent('adev:cart-drawer:loading', { detail: false }));

            this.initQuantityChange();
            this.initCloseButton();
        }

        submitForm() {
            document.dispatchEvent(new CustomEvent('adev:cart-drawer:loading', { detail: true }));
            
            const formEl = this.querySelector('[data-adev-cart-drawer="form"]');

            const formData = new FormData(formEl);
            formData.append('sections', 'adev-cart-drawer');
			formData.append('sections_url', window.location.pathname);

            fetch(theme.routes.cartUpdateUrl, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
            .then(response => {
                return response.json();
            })
            .then(data => {
                document.dispatchEvent(new CustomEvent('adev:cart-drawer:refresh', { detail: data.sections }));
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
                document.dispatchEvent(new CustomEvent('adev:cart-drawer:loading', { detail: false }));
            });
        }

        init(){
            this.setupEvents();
            this.initQuantityChange();
            this.initCloseButton();
        }

        connectedCallback() {
            this.init();
        }

        disconnectedCallback() {
            
        }

    });
}

if (!customElements.get('adev-remove-cart-item')) {
    customElements.define('adev-remove-cart-item', class adevRemoveCartItem extends HTMLElement {
        constructor() {
            super();
        }

        _removeItem(e) {
            e.preventDefault();
            
            const key = this.getAttribute('data-key');
            if (!key) return;

            document.dispatchEvent(new CustomEvent('adev:cart-drawer:loading', { detail: true }));

            const formData = new FormData();
            formData.append('id', key);
            formData.append('quantity', 0);
            formData.append('sections', 'adev-cart-drawer');

            fetch(theme.routes.cartChangeUrl, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
            .then(response => {
                return response.json();
            })
            .then(data => {
                document.dispatchEvent(new CustomEvent('adev:cart-drawer:refresh', { detail: data.sections }));
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
                document.dispatchEvent(new CustomEvent('adev:cart-drawer:loading', { detail: false }));
            });
        }

        connectedCallback() {
			if (this.hasAttribute('data-adev-remove-cart-item')) {
                this.addEventListener('click', this._removeItem.bind(this));
            } else {
                this.querySelectorAll('[data-adev-remove-cart-item]').forEach((btn) => {
                    btn.addEventListener('click', this._removeItem.bind(this));
                });
            }
        }

        disconnectedCallback() {
            if (this.hasAttribute('data-adev-remove-cart-item')) {
                this.removeEventListener('click', this._removeItem.bind(this));
            } else {
                this.querySelectorAll('[data-adev-remove-cart-item]').forEach((btn) => {
                    btn.removeEventListener('click', this._removeItem.bind(this));
                });
            }
        }

    });
}


document.querySelectorAll('[data-adev-open-cart]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('adev:open-cart-drawer'));
    });
});